import { useContext } from 'react';
import { Formik, Form } from 'formik';
import { CircleLoader, Page, PageHeader } from 'components';
import { newTicketContext } from './NewTicketContext';
import { NewTicketForm } from './components';
import { Container } from '@mui/material';
import { applicationContext } from 'helpers/services';
import { useLocation } from 'react-router';

let NewTicket = () => {
    let location = useLocation();

    let service = useContext(newTicketContext);
    let appService = useContext(applicationContext);

    return (
        <Container maxWidth="lg">
            <Page title={`Nuovo ticket ${service.fromMessage === true ? 'dal messaggio' : ''}`}>
                <PageHeader pageTitle={`Nuovo ticket ${service.fromMessage === true ? 'dal messaggio' : ''}`} />
                <Formik
                    enableReinitialize={true}
                    validationSchema={service.newTicketSchema}
                    initialValues={{
                        ...service.newTicketSchema.getDefault(),
                        categoryId: appService.ticketCategories[0].ticketCategoryId,
                        emailId: new URLSearchParams(location.search).get("emailId") || ''
                    }}
                    onSubmit={(values, action) => {
                        service.saveNewTicket(values as any);
                        action.setSubmitting(false);
                    }}
                >
                    {formProps =>
                        <Form>
                            {service.isLoading && <CircleLoader />}
                            {service.isLoading === false && <NewTicketForm formProps={formProps} />}
                        </Form>
                    }
                </Formik>
            </Page>
        </Container>
    );
}

export default NewTicket;